import { AppointmentAndGuestsTable } from "./smartComponents/appointmentAndGuestsTable";
import { AttritionTable } from "./smartComponents/attritionTable";
import { GuestsAndActivitiesPies } from "./smartComponents/guestsAndActivitiesPies";
import { IndicatorsTable } from "./smartComponents/indicatorsTable";
import { PiesAndTable } from "./smartComponents/piesAndTable";

export const SECTIONS = [
  {
    Component: IndicatorsTable,
    key: "indicatorsTable",
    urn: "key_performance_indicators_table"
  },
  {
    Component: AppointmentAndGuestsTable,
    key: "appAndGuestsTable",
    urn: "appointments_and_guests_table"
  },
  {
    Component: GuestsAndActivitiesPies,
    key: "guestsAndActivitiesPies",
    urn: "guests_and_activities_pie_charts"
  },
  {
    Component: PiesAndTable,
    key: "utilizationPieAndTable",
    urn: "daily_pulse_utilization_chart",
    pieTitle: "UTILIZATION MTD",
    tableTitle: "UTILIZATION"
  },
  {
    Component: PiesAndTable,
    key: "visitsPieAndGuestsTable",
    urn: "first_time_guests_chart",
    pieTitle: "1ST VISIT CLOSING",
    tableTitle: "1ST TIME GUESTS"
  },
  {
    Component: AttritionTable,
    key: "membershipAndAttritionTable",
    urn: "membership_and_attrition_table"
  }
];
